export const VENDOR_CATEGORY = {
  AD_NETWORK: "Ad Network",
  PAYMENT_PROCESSOR: "Payment Processor",
  SHIPPING_SERVICE: "Shipping Service",
  RETAIL_PARTNER: "Retail Partner",
  DATA_BROKER: "Data Broker",
  DATA_ANALYTICS_PROVIDER: "Data Analytics Provider",
  APPLICANT_TRACKING: "Recruitment & Applicant Tracking System",
  RECRUITMENT_SERVICE: "Recruitment Service",
  BACKGROUND_CHECK_PROVIDER: "Background Check Provider",
  SALES_MARKETING_TOOL: "Sales & Marketing Tool",
  CO_MARKETING_PARTNER: "Co-Marketing Partner",
  COMMUNICATION_TOOLS: "Communications Tool",
};

export type VendorCategory = typeof VENDOR_CATEGORY[keyof typeof VENDOR_CATEGORY];

// todo: refactor references to the below VENDOR_CATEGORY_ consts to use the above VENDOR_CATEGORY map
export const VENDOR_CATEGORY_AD_NETWORK = VENDOR_CATEGORY.AD_NETWORK;
export const VENDOR_CATEGORY_RETAIL_PARTNER = VENDOR_CATEGORY.RETAIL_PARTNER;
export const VENDOR_CATEGORY_DATA_BROKER = VENDOR_CATEGORY.DATA_BROKER;
export const VENDOR_CATEGORY_DATA_ANALYTICS_PROVIDER = VENDOR_CATEGORY.DATA_ANALYTICS_PROVIDER;
export const VENDOR_CATEGORY_APPLICANT_TRACKING = VENDOR_CATEGORY.APPLICANT_TRACKING;
export const VENDOR_CATEGORY_RECRUITMENT_SERVICE = VENDOR_CATEGORY.RECRUITMENT_SERVICE;
export const VENDOR_CATEGORY_BACKGROUND_CHECK_PROVIDER = VENDOR_CATEGORY.BACKGROUND_CHECK_PROVIDER;
export const VENDOR_CATEGORY_SALES_MARKETING_TOOL = VENDOR_CATEGORY.SALES_MARKETING_TOOL;

export const VENDOR_KEY_TRUEVAULT = "truevault";
export const VENDOR_KEY_TRUEVAULT_CONNECTED_SYSTEM = "truevault-connected-system";
export const VENDOR_KEY_GOOGLE_ANALYTICS = "google-analytics";
export const VENDOR_KEY_SHOPIFY = "shopify";
export const VENDOR_KEY_SHOPIFY_AUDIENCES = "shopify-audiences";
export const VENDOR_KEY_GOOGLE_ADS = "google-ads";
export const VENDOR_KEY_FB_ADS = "facebook-ads";
export const VENDOR_KEY_PAYPAL = "paypal";

export const SOURCE_KEY_CONSUMER_DIRECTLY = "source-consumer-directly";
export const SOURCE_KEY_OTHER_INDIVIDUALS = "source-other-individuals";

export const VENDOR_CLASSIFICATION_SLUG_SERVICE_PROVIDER = "service-provider";
export const VENDOR_CLASSIFICATION_SLUG_THIRD_PARTY = "third-party";

export const CONTRACTOR_CATEGORY = {
  IT: "IT Contractors",
  SALES_MARKETING: "Sales & Marketing Contractors",
  ACCOUNTING: "Accounting Contractors",
  CUSTOMER_SUPPORT: "Customer Support Contractors",
  HUMAN_RESOURCES: "Human Resources Contractors",
  DATA_ENTRY: "Data Entry Contractors",
  ENGINEERING: "Engineering Contractors",
  SECURITY: "Security Contractors",
  CONSULTANT: "Consultant Contractors",
  ORDER_FULFILLMENT: "Order Fulfillment Contractors",
};
